import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import CardGroup from "react-bootstrap/CardGroup";

function HomeCards() {
  return (
    <>
      <Container fluid="lg">
        <CardGroup className="CardGroup padding-spacing">
          <Card style={{ width: "100%" }}>
            <Card.Body className="flex flex-col justify-center items-center">
              <h1 style={{ textAlign: "center" }}>
                WE WILL BE BACK 5th & 6th SEPTEMBER 2026
              </h1>
              <h3 style={{ textAlign: "center" }}>
                Stay tuned for entry information
              </h3>
              <Card.Text>
                <p>
                  Congratulations to everybody that took part in The first ever
                  Cheshire 100 run in some really tough conditions.
                </p>
                <p>
                  The wind and rain were relentless throughout the afternoon of
                  the 20th and continuing into the night but you all battled
                  through really well! The sun came out the following morning
                  and I think that was a great relief after spending the last
                  day soaked.
                </p>
                <p>
                  Well done to those who completed their first ever 100 and also
                  congratulations to those who had completed the furthest
                  distances they had ever run before! So many achievements to be
                  celebrated across the board.
                </p>
                <p>
                  We are glad to announce that we will be hosting the Cheshire
                  100 Ultra Run again on the{" "}
                  <b>5th and 6th of September 2026</b>. Keep an eye on our
                  website and social media pages where we will announce when we
                  can begin accepting entries!
                </p>
              </Card.Text>
            </Card.Body>
            <div className="text-center pb-3">
              <div className="flex justify-center items-center space-x-4 mt-6">
                <Button
                  href="https://www.eventbrite.com/e/the-cheshire-100-ultra-run-tickets-1761704017139?aff=erelexpmlt"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="primary"
                  className="button px-4 py-3 text-xl mx-2 flex justify-center items-center text-center"
                >
                  <p className="m-0">
                    <b>PURCHASE TICKETS</b>
                  </p>
                </Button>

                <Button
                  href="https://www.facebook.com/p/The-Cheshire-100-Ultra-Run-100091617470110/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="primary"
                  className="button px-4 py-3 text-xl mx-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                  </svg>
                </Button>

                <Button
                  href="https://www.instagram.com/Cheshire_100nw/?fbclid=IwY2xjawNGek1leHRuA2FlbQIxMABicmlkETBNZktGbE1pTWdLeG1BSHNLAR7H54nRRhiDh3bJ_xZNHEvKaPbqnYdamP_EAAxg0150HVlusBtDXf8yJOzwIQ_aem_1gTVGG0uPSLWJKxPjRyNsg#"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="primary"
                  className="button px-4 py-3 text-xl mx-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </Button>
              </div>
            </div>
          </Card>
        </CardGroup>

        <CardGroup className="CardGroup padding-spacing">
          <Card style={{ width: "100%" }}>
            <Card.Body className="flex flex-col justify-center items-center">
              <Card.Title>ABOUT THE RACE</Card.Title>
              <Card.Text>
                <p>
                  The Cheshire 100 is an exciting new ultra-distance race which
                  covers the heart of Cheshire including Manchester. This is a
                  100 mile continuous race which starts in Northwich, Cheshire
                  and covers the traditional 'Cheshire ring' canal route in a
                  clockwise direction. Navigating along no less than 6 different
                  canals the route is scenic, easy to follow and relatively
                  flat.
                </p>
                <p>
                  This race has been organised by New Era Community boxing which
                  is registered as a community interest company, based in
                  Northwich, Cheshire. The club has been offering training and
                  support for young people across the area since 2011.
                </p>
                <p>
                  The race is inspired by the Cheshire canal ring route, which
                  the race follows along. Mark, the lead coach from New Era
                  Community boxing completed the route in 2020 and in doing so
                  raised money for Cheshire young carers.
                </p>
                <p>
                  Since completing the route, it has been our ambition to
                  promote the Cheshire canal ring with this event offering the
                  opportunity to take part in a exciting, affordable ultra
                  running event.
                </p>
              </Card.Text>
            </Card.Body>
          </Card>

          {/* <Card style={{ width: "100%" }}>
            <Card.Body>
              <Card.Title>PRICING</Card.Title>
              <Card.Text>
                <p>
                  Supported: £80, Unsupported: £100, including booking fees if
                  applicable. (Please add £2 extra if unattached to a UK club.)
                </p>
                <p>
                  Fees from successful applicants will become due upon
                  acceptance via the booking system
                </p>
                <ul>
                  <li>
                    Cancellations before 31st May 2025 will receive a full
                    refund.
                  </li>
                  <li>
                    A 75% refund will be paid if the organiser is notified
                    between 1st and 30th June 2025.
                  </li>
                  <li>
                    A 50% refund will be paid if the organiser is notified
                    between 1st and 31st July 2025. No refunds of the entry fee
                    will be made after the 31st July 2025.
                  </li>
                </ul>
                <p>
                  To cancel a place, message cheshire100nw@gmail.com as soon as
                  the decision is made.
                </p>

                <p>
                  If more than 180 days have passed since the original card
                  transaction, we will make any refund due via bank transfer to
                  the details provided; in this case make sure to include bank
                  account number and sort code details.
                </p>

                <p>
                  N.B. If the organiser cancels the event due to unforseen
                  circumstances a full refund will be offered or a transfer to
                  the rescheduled event.
                </p>
              </Card.Text>
            </Card.Body>
          </Card> */}
        </CardGroup>

        {/* <CardGroup className="CardGroup padding-spacing">
          <Card style={{ width: "100%" }}>
            <Card.Body>
              <Card.Title>BENEFITS OF ENTERING THE CHESHIRE 100</Card.Title>
              <Card.Text>
                <ul>
                  <li>
                    Easy route navigation – detailed maps and clear pre-race
                    guidance provided.
                  </li>
                  <li>Pre-race advice and support for every participant.</li>
                  <li>
                    Plenty of support on route – snacks and drinks at every
                    checkpoint.
                  </li>
                  <li>
                    An accessible route for support teams and buddy runners
                    throughout.
                  </li>
                  <li>
                    Transport for retirees – a lift to the nearest station
                    available for anyone having a bad day.
                  </li>
                  <li>
                    Easy to meet cut-off times – simply in line with the
                    generous overall time limits.
                  </li>
                  <li>
                    No qualification – previous experience of just a marathon
                    has proven enough.
                  </li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: "100%" }}>
            <Card.Body>
              <Card.Title>HOW DO I JOIN?</Card.Title>
              <Card.Text>
                Whether you are a novice, a seasoned runner or anywhere
                in-between, you are welcome to join the ultra race. There are no
                entry requirements other than that you must be over twenty years
                old and up for giving the race your best effort. Before deciding
                whether you would like to enter, please ensure you have:
                <br></br>
                <br></br>
                <ul>
                  <li>
                    Read the <a href="/pre-race-notes">Route Information</a>
                  </li>
                  <li>
                    Read the <a href="/pre-race-notes">Pre-Race Notes</a>
                  </li>
                  <li>
                    Read the <a href="/rules">Rules</a>
                  </li>
                  <li>
                    Read the <a href="/terms-conditions">Terms & Conditions</a>
                  </li>
                </ul>
                Ready to join the race? Great! Simply click the button below or
                scroll to the bottom of this page to purchase a ticket for the
                event.
              </Card.Text>
              <Button variant="primary" href="/how-to-enter" className="button">
                How to enter
              </Button>
            </Card.Body>
          </Card>
        </CardGroup> */}
      </Container>
    </>
  );
}

export default HomeCards;
